import styled from "styled-components";

export const Container = styled.div`
  width: 294px;
  padding: 25px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
  border-radius: 6.97113px;
  border: 1px solid #E3E3E3;
  background: #FFFFFF;
`;